import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "I learned two things today 11.8.",
  "description": "",
  "published": "2011-08-11T00:00:00.000Z",
  "redirect_from": ["/blog/i-learned-two-things-today-11-8/swizec/2150"],
  "categories": "Academy Award, Appcelerator, Appcelerator Titanium, AudreyHepburn, JavaScript, Learning, Personal, Roman Holiday, Stanford Theatre",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/08/300px-Audrey_Hepburn_screentest_in_Roman_Holiday_trailer_25.jpg",
        "alt": "Cropped screenshot of Audrey Hepburn from the ...",
        "title": "Cropped screenshot of Audrey Hepburn from the ..."
      }}></img></p>
    <p>{`Today I learned that old movies are even better when you watch them in a proper vintage theatre. Went to `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=37.44507,-122.1627&spn=0.01,0.01&q=37.44507,-122.1627%20(Stanford%20Theatre)&t=h",
        "title": "Stanford Theatre"
      }}>{`Stanford Theatre`}</a>{` to watch `}<a parentName="p" {...{
        "href": "http://www.rottentomatoes.com/celebrity/audrey_hepburn",
        "title": "Audrey Hepburn"
      }}>{`Audrey Hepburn`}</a>{`'s `}<a parentName="p" {...{
        "href": "http://www.rottentomatoes.com/m/roman_holiday",
        "title": "Roman Holiday"
      }}>{`Roman Holiday`}</a>{` and it was quite possibly the best moviegoing experience I have ever had. There's just something special about going to a place where they still put up the schedule above the front door like you sometimes see in "old" movies ... then again, a lot of places around here still seem to do that.`}</p>
    <p>{`And I really loved the fact that even though this was a `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Romantic_comedy_film",
        "title": "Romantic comedy film"
      }}>{`romantic comedy`}</a>{` it didn't have one of those gushy sugary endings where the main characters end up living happily ever after. There was closure, yes, but a happy ending ... guess it depends on how you look at it.`}</p>
    <p>{`Another thing that I learned today is that `}<a parentName="p" {...{
        "href": "http://www.appcelerator.com/",
        "title": "Appcelerator Titanium"
      }}>{`Appcelerator`}</a>{` is pretty cool technology. Haven't managed to play too much with it because I was struggling with the `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Integrated_development_environment",
        "title": "Integrated development environment"
      }}>{`IDE`}</a>{` they shove down your throat when you're starting out, but it looks like it might add a whole new possible dimension to what I can do with `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/JavaScript",
        "title": "JavaScript"
      }}>{`JavaScript`}</a>{`.`}</p>
    <p>{`But I guess we'll see tomorrow when I start to really play around with the thing.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://swizec.com/blog/i-learned-two-things-today-2-8/swizec/2059"
        }}>{`I learned two things today 2.8.`}</a>{` (swizec.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://blog.rubylane.com/node/2201"
        }}>{`Audrey Hepburn - Actress, Philantrhopist and Style Icond`}</a>{` (rubylane.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://sistercharming.wordpress.com/2011/07/10/audreys-charm/"
        }}>{`Audrey's Charm`}</a>{` (sistercharming.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://classnfab.wordpress.com/2011/08/03/top-10-iconic-audrey-hepburn-outfits/"
        }}>{`Top 10 Iconic Audrey Hepburn Outfits`}</a>{` (classnfab.wordpress.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=0ae4624c-4423-4626-bedf-7bb768015c8a",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      